import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { setValue } from '../../utils';
import { CONTROL } from './constants';
export function getDefaultValues(controls) {
  var defaultValue = {};
  function internalGetDefaultValues(controls) {
    Object.entries(controls).forEach(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        control = _ref2[1];
      if (control) {
        switch (control.type) {
          case CONTROL.Object:
            {
              if (control.defaultValue !== undefined) {
                setValue(defaultValue, key, JSON.parse(JSON.stringify(control.defaultValue)));
              }
              internalGetDefaultValues(control.controls);
              break;
            }
          case CONTROL.ToggleObject:
            {
              setValue(defaultValue, control.switchKey, false);
              internalGetDefaultValues({
                _: control.control
              });
              break;
            }
          case CONTROL.Alert:
            {
              break;
            }
          default:
            {
              if (control.defaultValue !== undefined) {
                var _control$accessorKey;
                var restedValue = JSON.parse(JSON.stringify(control.defaultValue));
                setValue(defaultValue, (_control$accessorKey = control === null || control === void 0 ? void 0 : control.accessorKey) !== null && _control$accessorKey !== void 0 ? _control$accessorKey : '', restedValue);
              }
            }
        }
      }
    });
  }
  internalGetDefaultValues(controls);
  return defaultValue;
}